<template>
  <div class="fastCheck full-height fastCheck-banner">
    <ld-header
      @click-left="back"
      transparent
      white
    >
      <img
        slot="left"
        class="custom-back"
        src="~Assets/images/back.png"
      >
      <!-- <trip-type slot="right" /> -->
    </ld-header>

    <div class="fastCheckwrapper">
      <mescroll-vue
        ref="mescroll"
        :down="down"
      >
        <div>
          <!-- <div class="list">
            <span class="font16 font-bold">快速安检通道</span>
          </div> -->
          <div class="top">
            &nbsp;
          </div>
          <!-- <tab-block
            :tab-index="productType"
            @on-tabLeft-click="productType = 0"
            @on-tabRight-click="productType = 1"
          >
            <span slot="tab_left">机场</span>
            <span slot="tab_right">高铁</span> -->
          <div class="list">
            <div class="box">
              <div v-show="productType==0">
                <van-field
                  label="选择服务机场"
                  placeholder="请选择服务机场"
                  readonly
                  :value="`${cityName} ${serverAirportName}`"
                  @click="$refs.city.toggle()"
                >
                  <template #button>
                    <span
                      class="dBtn main-color"
                      @click.stop="myFlight"
                    >
                      我的航班
                    </span>
                  </template>
                </van-field>
                <van-field
                  label="选择出发类型"
                  is-link
                  readonly
                  @click="showType=!showType"
                  v-model="leaveTypeName"
                />
                <van-action-sheet
                  description="选择出发类型"
                  cancel-text="取消"
                  v-model="showType"
                  :actions="typeArr"
                  @select="selType"
                />
                <van-field
                  label="选择航站楼"
                  v-model="terminalName"
                  is-link
                  @click="showTerminal = !showTerminal"
                  input-align="left"
                  readonly
                />
                <van-action-sheet
                  description="选择航站楼"
                  cancel-text="取消"
                  v-model="showTerminal"
                  :actions="terminalArr"
                  @select="selTerminal" 
                />
              </div>
              <div v-show="productType==1">
                <van-field
                  label="选择服务车站"
                  placeholder="请选择服务车站"
                  readonly
                  v-model="serverAirportName"
                  @click="$refs.city.toggle()"
                >
                  <template #button>
                    <span
                      class="dBtn main-color"
                      @click.stop="myTrain"
                    >
                      我的车次
                    </span>
                  </template>
                </van-field>
              </div>
            </div>

            <van-tabs
              v-model="active"
              line-height="3"
            >
              <van-tab title="服务信息">
                <van-field
                  label="服务价格"
                  :border="false"
                >
                  <template #extra>
                    <div class="gray">
                      &yen; {{ detail.salePrice+detail.serviceFee || 0 }}
                    </div>
                  </template>
                </van-field>
                <van-field
                  label="营业时间"
                  :border="false"
                >
                  <template #extra>
                    <div class="gray">
                      <span v-show="detail.businessHoursStar">{{ detail.businessHoursStar }}-{{ detail.businessHoursEnd }}</span>
                    </div>
                  </template>
                </van-field>
                <van-field
                  label="服务介绍"
                  :border="false"
                >
                  <template #extra>
                    <div class="gray">
                      {{ detail.serverIntroduce }}
                    </div>
                  </template>
                </van-field>
                <van-field
                  label="路线指引"
                  :border="false"
                >
                  <template #extra>
                    <div class="gray">
                      {{ detail.address }}
                    </div>
                  </template>
                </van-field>
              </van-tab>
              <van-tab title="购买须知">
                <van-field
                  label="有效期"
                  :border="false"
                >
                  <template #extra>
                    <div class="gray">
                      {{ detail.validity }}天
                    </div>
                  </template>
                </van-field>
                <van-field
                  label="使用方式"
                  :border="false"
                >
                  <template #extra>
                    <div class="gray">
                      {{ detail.usageExplain ||'请至少在您所乘坐的航班关闭舱门前25分钟使用，无需预约，在接待位置出示使用凭证即可。' }}
                    </div>
                  </template>
                </van-field>
                <van-field
                  label="退款说明"
                  :border="false"
                >
                  <template #extra>
                    <div class="gray">
                      {{ detail.refundExplain ||'如服务未使用，支持随时退款，支持过期退款。' }}
                    </div>
                  </template>
                </van-field>
              </van-tab>
            </van-tabs>
          </div>
        </div>
      </mescroll-vue>
    </div>

    <!--  -->
    <ld-tabbar
      ref="tabbar"
      class="bg-white shadow"
    >
      <van-row
        class="full-width"
        type="flex"
        align="center"
        gutter="8"
        justify="center"
      >
        <van-col
          span="22"
        >
          <ld-button
            main
            size="md"
            @click="order"
          >
            购买服务
            <span class="font-lg text-right text-space-1">
              ( <span class="font10">&yen;</span>
              <span class="font16 ">{{ detail.salePrice }}</span> )
            </span>
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>

    <!-- 城市 -->
    <city
      ref="city"
      @selected="changeCity"
      cplx="10915"
      :city-type="cityType"
      hot-span="8"
      history-span="8"
      :cityjczd-name="true"
    />
    <!--航班列表  -->
    <car-flights
      ref="myFlights"
      :data="myFlightData"
      @selected="flightSel"
      :use-type="myflt"
    />
    <!--  -->
    <van-popup
      v-model="showTrain"
      round
      position="bottom"
      class="full-width"
    >
      <div style="height:70vh;">
        <van-cell>
          车次信息
        </van-cell>
        <van-cell
          v-for="(item,index) in myTrainData"
          :key="index"
          @click="selMyTrain(item)"
        >
          <van-row class="text-center">
            <van-col span="8">
              <div class="font20 black text-space-1">
                {{ item.fromStationName }}
              </div>
              <div class="font14 pad gray">
                {{ item.fromTime }}
              </div>
            </van-col>
            <van-col span="8">
              {{ item.trainCode }}
              <icon-arrow-line />
            </van-col>
            <van-col span="8">
              <div class="font20 black text-space-1">
                {{ item.toStationName }}
              </div>
              <div class="font14 pad gray">
                {{ item.toTime }}
              </div>
            </van-col>
          </van-row>
          <van-row class="font12">
            <van-col span="1" />
            <van-col span="15">
              出发日期：{{ item.fromDate }}
            </van-col>
            <van-col span="8">
              座位号：{{ item.chooseSeats }}
            </van-col>
          </van-row>
        </van-cell>
      </div>
      <!-- 火车票列表组件 -->
      <!-- <train-common
        class="train-commmon"
        :list="myTrainData"
        @selected="selMyTrain"
      /> -->
    </van-popup>
  </div>
</template>

<script>
import {Field,Cell,Tag ,DatetimePicker,ActionSheet,Tab, Tabs,Popup} from 'vant'
import { mapGetters } from 'vuex'
import ldButton from 'Common/ldButton'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import City from 'Common/city'
import carFlights from 'Views/Car/carQuery/flight/carFlights'
import MescrollVue from 'mescroll.js/mescroll.vue'
// import tabBlock from 'Components/tab-block'
import iconArrowLine from 'Common/iconArrowLine'
import { localget, localset } from 'Utils/storage.js'

export default {
  name: 'CheckIn',
  components:{
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [DatetimePicker.name]: DatetimePicker,
    [ActionSheet.name]: ActionSheet,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Popup.name]: Popup,
    // tripType,
    ldTabbar,
    ldButton,
    City,
    carFlights,
    MescrollVue,
    // tabBlock,
    iconArrowLine
    // TrainCommon
  },
  data () {
    return {
      down:{use:false},
      active:0,
      pnum:0,
      serverAirportName:'首都国际机场',
      serverAirportCode:'PEK',
      cityName:'北京',
      leaveType:1,
      leaveTypeName:'国内出发',
      showType:false,
      typeArr : [
        {value:'1',name:'国内出发'},
        {value:'2',name:'国际出发'},
      ],
      terminal:'',
      terminalName:'',
      showTerminal: false,
      terminalArr:[],
      productType:0,
      myflt:false,
      myFlightData:[],
      showTrain:false,
      myTrainData:[],
      relateOrder:'',
      cityType:0,//
    }
  },
  computed: {
    ...mapGetters({
      userInfo:'userInfo',
      // travelerList: 'fastCheck/travelerList',
      detail: 'fastCheck/detail',
    }),
  },
  created () {
    try {
      let historyLog=localget('_historyLog')||{}
      if(historyLog.fastCheck){
        if(historyLog.fastCheck.productType==2){
          historyLog.fastCheck.productType=1
        }else{
          historyLog.fastCheck.productType=0
        }
        Object.assign(this,historyLog.fastCheck)
      }
    } catch (error) {
      console.log(error)
    }
  },
  mounted(){
    if(Object.keys(this.detail).length==0){
      this.query()
    }
    this.queryTerminal(this.serverAirportCode)
  },
  methods:{
    query(){
      this.$api['airService/fastCheckQuery']({
        'productType': this.productType+1,//产品类型 1 机场 2火车站 ,
        'airTrainCode': this.serverAirportCode,//机场三字码或火车站点 ,
        'terminal': this.terminal,//航站楼
        'leaveType': this.leaveType,//出发类型
      }).then((res) => {
        let cache = res.data || {}
        this.$store.commit('fastCheck/setDetail',cache)
      }).catch(res=>{
        console.log(res)
      })
    },
    order(){
      if(this.detail.id){
        let params={
          productType:this.productType+1,
          terminal:this.terminal,
          terminalName:this.terminalName,
          leaveType:this.leaveType,
          leaveTypeName:this.leaveTypeName,
          serverAirportName:this.serverAirportName,
          serverAirportCode:this.serverAirportCode,
        }
        this.$store.commit('fastCheck/params',params)
        try {
          let historyLog=localget('_historyLog')||{}
          historyLog.fastCheck=params
          localset('_historyLog',historyLog)
        } catch (error) {
          console.log(error)
        }
        this.$store.commit('fastCheck/searchInfo',this.detail)
        this.$router.push({path:'/fastCheck/edit'})
      }
    },
    // 选中服务类型
    selType(item) {
      this.showType = false
      this.leaveType = item.value
      this.leaveTypeName=item.name
      this.query()
    },
    // 选择机场
    changeCity(info){
      this.serverAirportName=info.jcZdName
      this.serverAirportCode=info.jcZdCode
      this.cityName=info.cityName
      this.queryTerminal(info.jcZdCode)
    },
    //查航站楼
    queryTerminal(threeCode) {
      if (threeCode) {
        this.$api['carQuery/queryApTrnInfo']({ threeCode: threeCode }).then(res => {
          let cache = res.data || []
          if (cache.length > 0) {
            cache.forEach(ele => {
              ele.name = ele.terminalName
              ele.value = ele.terminal
            })
            this.terminalArr = cache
          }else{
            this.terminal=''
            this.terminalName=''
          }
        })
      }
    },
    flightSel(info){
      if(this.leaveType==1){
        this.serverAirportName=info.departAirportName
        this.threeCode=info.departAirport
        this.cityName=info.departCityName
        if(info.departTerminal){
          this.terminal=info.departTerminal
          this.terminalName=info.departTerminal+'航站楼'
        }
        this.queryTerminal(info.departAirport)
      }else{
        this.serverAirportName=info.arriveAirportName
        this.threeCode=info.arriveAirport
        this.cityName=info.arriveCityName
        if(info.arriveTerminal){
          this.terminal=info.arriveTerminal
          this.terminalName=info.arriveTerminal+'航站楼'
        }
        this.queryTerminal(info.arriveAirport)
      }
    },
    //选中航站楼
    selTerminal(item){
      this.showTerminal=false
      this.terminal=item.value
      this.terminalName=item.name
      this.query()
    },
    myFlight() {
      this.myflt=true
      //获取系统内机票订单
      //业务类型 1接送 2送机 不能为空
      this.$api['common/queryWcxOrder']({ ywlx: 1 }).then(res => {
        let cache = res.data || []
        cache.reverse()
        if (cache.length > 0) {
          this.myFlightData = cache
          this.$refs.myFlights.toggle()
        } else {
          this.$toast('未查询到您的航班信息')
        }
      })
    },
    myTrain(){
      this.$api['common/queryTrainNumber']({
        'booker': this.userInfo.empInfo.empId,
      }).then(res => {
        let cache = res.data || {}
        let list=cache.obtQueryTrNumberBeanList || []
        if(list.length){
          this.myTrainData=list
          this.showTrain=true
        }
      })
    },
    selMyTrain(info){
      this.serverAirportName=info.fromStationName
      this.serverAirportCode=info.fromStationCode
      this.cityName=info.cityName
      this.showTrain=false
      this.query()
    },
    //返回
    back() {
      this.$store.commit('fastCheck/CLEAR_ALL')
      this.$router.push({path:'/home'})
    },
  },
  watch: {
    'productType'(val){
      if(val==0){
        this.cityType=0
      }else{
        this.cityType=2
      }
      this.serverAirportName=''
      this.serverAirportCode=''
      this.cityName=''
      this.detail={}
    }
  }
}
</script>

<style lang="less" scoped>
.fastCheck{
    background-repeat: no-repeat;
    background-size: contain;
}
.top{
    padding-top: 100px;
}

.list{
    padding: 10px;
}
.box{
    padding-bottom: 5px;
}
.dBtn {
    display: inline-block;
    width: 1.35rem;
    height: 0.48rem;
    line-height: 0.46rem;
    text-align: center;
    border-radius: 24px;
    border: 1px solid;
    font-size: @font-size-12;
}
.fastCheckwrapper {
    height: calc(100vh - 96px);
    overflow: hidden;
}
</style>
